import Link from 'next/link';
import { FeedAuthor } from '@/platform/feed/FeedAuthor';
import type { BlogPost } from './api';
import { plainTextExcerpt } from './content';

type Props = {
  post: BlogPost;
  excerptLength?: number;
  disableNavigation?: boolean;
  hrefOverride?: string;
  authorFixture?: { displayName?: string; handle?: string; avatarUrl?: string };
  onSelectAuthor?: (userId: string) => void;
};

export function BlogFeedCard({
  post,
  excerptLength = 200,
  disableNavigation = false,
  hrefOverride,
  authorFixture,
  onSelectAuthor,
}: Props) {
  const href = hrefOverride ?? `/blog/${post.slug}/`;
  const excerpt = plainTextExcerpt(post.body, excerptLength);
  const when = post.publishedAt ?? post.createdAt;
  const linked = !disableNavigation;

  return (
    <article className="feed-card feed-card--social">
      <FeedAuthor
        userId={post.authorId}
        createdAt={when}
        meta="Blog"
        fixtureProfile={authorFixture}
        disableProfileLink={!onSelectAuthor && (!!authorFixture || disableNavigation)}
        onSelectAuthor={onSelectAuthor}
      />
      <div className="feed-card__body">
        <h3 className="feed-card__title">
          {linked ? <Link href={href}>{post.title}</Link> : post.title}
        </h3>
        {excerpt && <p className="feed-card__excerpt">{excerpt}</p>}
      </div>
      <footer className="feed-card__actions">
        {linked ? (
          <Link href={href} className="feed-card__cta">
            Read post
          </Link>
        ) : null}
      </footer>
    </article>
  );
}
